<!--
 * @Author: your name
 * @Date: 2020-08-24 22:29:38
 * @LastEditTime: 2022-11-08 16:30:30
 * @LastEditors: 逐梦的风很轻 1114532270@qq.com
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/components/SvgIcon/index.vue
-->
<template>
  <div v-if="isExternal" :style="styleExternalIcon" class="svg-external-icon svg-icon" v-on="$listeners" />
  <span v-else :class="svgBoxClass" :style="{color: color, fontSize: size}">
    <svg :class="svgClass" aria-hidden="true" v-on="$listeners">
      <use :xlink:href="iconName" />
    </svg>
  </span>

</template>

<script>
import { isExternal } from '@/utils/validate'

export default {
  name: 'SvgIcon',
  props: {
    iconClass: {
      type: String,
      required: true
    },
    className: {
      type: String,
      default: ''
    },
    svgBoxClass: {
      type: String
    },
    color: String,
    size: [String, Number], // Support 12, 12px, 12rem, etc   // 支持 '12'，'12px'，'12rem' 等
  },
  computed: {
    isExternal() {
      return isExternal(this.iconClass)
    },

    fontSize() {
      if (!this.size) return 'inherit'
      return isNaN(this.size) ? this.size : (this.size + 'px')
    },

    iconName() {
      return `#icon-${this.iconClass}`
    },

    svgClass() {
      if (this.className) {
        return 'svg-icon ' + this.className
      } else {
        return 'svg-icon'
      }
    },

    styleExternalIcon() {
      return {
        mask: `url(${this.iconClass}) no-repeat 50% 50%`,
        '-webkit-mask': `url(${this.iconClass}) no-repeat 50% 50%`
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.arrow
  height: 106px
  width: 106px
  margin-top: 30px
  margin-right: 25px
</style>

<style scoped>
.svg-icon {
  width: 100%;
  height: 100%;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}

.svg-external-icon {
  background-color: currentColor;
  mask-size: cover!important;
  display: inline-block;
}

</style>
